import React from 'react';
import { zoocasaNavigationConfig } from 'tenants/zoocasa/config/navigation';
import type { TenantNavigationConfig } from '@tenants/types';
import MenuIcon from 'components/atomic/atoms/icons/menu-icon';
import UserIcon from 'components/atomic/atoms/icons/user-icon';
import panelStyles from './navigation-panel.module.scss';

export const zoocasaLightNavigationConfig: TenantNavigationConfig = {
  ...zoocasaNavigationConfig,
  menuTrigger: <MenuIcon />,
  mobileUserTrigger: <UserIcon />,
  mobileMenuTrigger: <MenuIcon />,
  panelClassName: panelStyles['light-panel'],
};
